import { render } from "./ProblematicSitesTable.vue?vue&type=template&id=1209f08e&scoped=true"
import script from "./ProblematicSitesTable.vue?vue&type=script&lang=js"
export * from "./ProblematicSitesTable.vue?vue&type=script&lang=js"

import "./ProblematicSitesTable.vue?vue&type=style&index=0&id=1209f08e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1209f08e"]])

export default __exports__